module.exports = __webpack_public_path__ + "media/images/sections/content_connection-414e32a09f55f56f2e8278da9a2d91c0.png";